import { ref } from 'vue'

import type { MediaItem, MediaViewerController } from './types'

// Imperative controller for the lazy MediaViewer (contract 02 §9: `openViewer(items, startIndex)`).
// A module-level singleton so any call site opens the SAME viewer — mirroring how `useToast`/
// `useConfirm` drive a single host. The app shell (module 05) mounts one <MediaViewer> bound to
// this controller; primitives never own a global mount themselves. Kept store-free and pure so it
// ships before the shell and is unit-testable in isolation.
const isOpen = ref(false)
const items = ref<MediaItem[]>([])
const index = ref(0)

export function useMediaViewer(): MediaViewerController {
  function openViewer(nextItems: MediaItem[], startIndex = 0): void {
    items.value = nextItems
    index.value = startIndex
    isOpen.value = true
  }

  function close(): void {
    isOpen.value = false
  }

  return {
    get isOpen() {
      return isOpen.value
    },
    get items() {
      return items.value
    },
    get index() {
      return index.value
    },
    openViewer,
    close,
  }
}
